import { createSelector } from 'reselect'
import { NAME } from './constants'
import { Location } from './actions'

interface LocationsState {
  [key: string]:
    | Location[]
    | {
        [postalCode: string]: string
      }
  pendingRestorations: {
    [postalCode: string]: string
  }
}

interface RootState {
  [NAME]: LocationsState
}

export const getLocationsListSelector = createSelector(
  (state: RootState) => state[NAME],
  (loc) => loc.list
)

export const getLocationsListSelectorByPostalCode = (
  postalCode: string,
  state: RootState
) =>
  createSelector(
    () => state[NAME],
    (locations: LocationsState) => {
      return locations?.[postalCode]
    }
  )(state)

export const getCountyHashSelector = createSelector(
  (state: RootState) => state[NAME],
  (locations: LocationsState) => {
    const hash: { [county: string]: Location } = {}
    for (const [_, location] of Object.entries(locations)) {
      // Skip if location is not an array or is undefined
      if (Array.isArray(location)) {
        location.forEach((loc: Location) => {
          hash[loc.County] = loc
        })
      }
    }

    return hash
  }
)

export const getPendingRestorationSelector = (
  postalCode: string,
  state: RootState
) =>
  createSelector(
    () => state[NAME],
    (locations: LocationsState) => {
      return locations?.pendingRestorations?.[postalCode] || null
    }
  )(state)
